import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Helper para componer className de Tailwind con resolución de conflictos.
 * Combinación canónica clsx + tailwind-merge (patrón industria,
 * shadcn-ui, etc.).
 *
 * @example
 *   <button className={cn('px-4 py-2', isPrimary && 'bg-blue-500', className)} />
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
